(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PagarMeV5Factory', PagarMeV5Factory);

    PagarMeV5Factory.$inject = ['$resource'];

    function PagarMeV5Factory($resource) {
        return $resource('admin/api/pagar-me/showkase-pay-v5/recipient', {}, {
            'integrateRecipient': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateRecipient': {
                method: 'PUT',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'hasActiveExternalRecipient': {
                method: 'GET',
                url: 'admin/api/pagar-me/showkase-pay-v5/recipient/check-status',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'reconnectRecipient': {
                method: 'POST',
                url: 'admin/api/pagar-me/showkase-pay-v5/recipient/reconnect',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'generateKycLink': {
                method: 'POST',
                url: 'admin/api/pagar-me/showkase-pay-v5/recipient/kyc-link',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
